/* ============================================================
   Joelle LB — theme.js  (no decorative animation; quiet + reduced-motion safe)
   ============================================================ */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Mobile drawer */
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    function setOpen(s) {
      drawer.setAttribute('data-open', s ? 'true' : 'false');
      document.body.style.overflow = s ? 'hidden' : '';
      if (s) { var f = drawer.querySelector('a, button'); if (f) f.focus(); }
    }
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { setOpen(true); }); });
    drawer.querySelectorAll('[data-drawer-close], .drawer__scrim').forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') setOpen(false); });
  }

  /* Header dropdowns (keyboard / touch) */
  function initDropdowns() {
    document.querySelectorAll('.nav__dropdown').forEach(function (item) {
      var trigger = item.querySelector('.nav__dropdown-btn');
      var menu = item.querySelector('.nav__dropdown-menu');
      /* Parent items are real links now (click navigates). Only bind the click-toggle
         when the trigger is an actual <button>; hover/focus-within (CSS) still opens it. */
      if (!trigger || trigger.tagName !== 'BUTTON' || !menu) return;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var open = item.getAttribute('data-open') === 'true';
        item.setAttribute('data-open', open ? 'false' : 'true');
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
      item.addEventListener('focusout', function () {
        setTimeout(function () {
          if (!item.contains(document.activeElement)) { item.setAttribute('data-open', 'false'); trigger.setAttribute('aria-expanded', 'false'); }
        }, 0);
      });
    });
  }

  /* Reveal on scroll */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (reduceMotion || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Quantity steppers */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-step') === 'down' ? -1 : 1;
          var min = parseInt(input.getAttribute('min'), 10); if (isNaN(min)) min = 1;
          var val = parseInt(input.value, 10); if (isNaN(val)) val = min;
          input.value = Math.max(min, val + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* Product gallery thumbnails */
  function initProductGallery() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-main-image]');
      if (!main) return;
      gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () { var full = thumb.getAttribute('data-full'); if (full) main.src = full; });
      });
    });
  }

  /* Shop slider */
  function initSliders() {
    document.querySelectorAll('[data-slider-track]').forEach(function (track) {
      var scope = track.closest('section') || document;
      var prev = scope.querySelector('[data-slider-prev]');
      var next = scope.querySelector('[data-slider-next]');
      var behavior = reduceMotion ? 'auto' : 'smooth';
      var step = function () { return Math.min(track.clientWidth * 0.8, 640); };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: behavior }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: behavior }); });
    });
  }

  /* Marquee: duplicate items for a seamless -50% loop (from sections.js) */
  function initMarquee() {
    document.querySelectorAll('.marquee__track').forEach(function (track) {
      var base = track.innerHTML;
      var guard = 0;
      while (track.scrollWidth < window.innerWidth * 2 && guard < 12) { track.innerHTML += base; guard++; }
      track.innerHTML += track.innerHTML;
    });
  }

  /* Timeline: size datum leaders (dashed verticals from each plate to the axis) */
  function layoutDatum() {
    document.querySelectorAll('.tl-datum').forEach(function (d) {
      var axisBottom = 132;
      d.querySelectorAll('.tl-stage').forEach(function (st) {
        var plate = st.querySelector('.tl-plate'), leader = st.querySelector('.tl-leader');
        if (!plate || !leader) return;
        var top = parseFloat(getComputedStyle(plate).top) || 0;
        var plateBottom = top + plate.offsetHeight;
        var axisY = st.offsetHeight - axisBottom;
        leader.style.top = plateBottom + 'px';
        leader.style.height = Math.max(0, axisY - plateBottom) + 'px';
      });
    });
  }
  function initTimeline() {
    var tls = document.querySelectorAll('.tl');
    if (!tls.length) return;
    if ('IntersectionObserver' in window && !reduceMotion && !(window.Shopify && window.Shopify.designMode)) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.15 });
      tls.forEach(function (t) { io.observe(t); });
    } else {
      tls.forEach(function (t) { t.classList.add('in'); });
    }
    layoutDatum();
    requestAnimationFrame(function () { requestAnimationFrame(layoutDatum); }); // after first layout pass
    setTimeout(layoutDatum, 100);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(layoutDatum); } // display font shifts metrics
    window.addEventListener('load', layoutDatum);
    window.addEventListener('resize', layoutDatum);
    document.querySelectorAll('.tl-plate img').forEach(function (img) { if (!img.complete) img.addEventListener('load', layoutDatum); });
  }
  /* Shopify theme editor: re-run the datum layout whenever a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) {
    var scope = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    scope.querySelectorAll('.reveal, .tl').forEach(function (el) { el.classList.add('in'); });
    setTimeout(layoutDatum, 60);
    requestAnimationFrame(layoutDatum);
    initTabs(scope); initAccordion(scope); initCountdown(scope); initVideoFrame(scope); initFindMap(); initFit(scope);
  });

  /* Shop collection: category filter chips (by product tag) */
  function initFilters() {
    document.querySelectorAll('[data-filter]').forEach(function (filters) {
      var scope = filters.closest('section') || document;
      var grid = scope.querySelector('[data-filter-grid]');
      if (!grid) return;
      filters.querySelectorAll('.chip').forEach(function (chip) {
        chip.addEventListener('click', function (e) {
          e.preventDefault();
          filters.querySelectorAll('.chip').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          chip.setAttribute('aria-pressed', 'true');
          var cat = chip.getAttribute('data-cat');
          grid.querySelectorAll('.g-item').forEach(function (it) {
            var tags = ' ' + (it.getAttribute('data-tags') || '') + ' ';
            it.style.display = (cat === 'all' || tags.indexOf(' ' + cat + ' ') !== -1) ? '' : 'none';
          });
        });
      });
    });
  }

  /* Botanical "Where to find it" map — vintage B&W OpenTopoMap, regional, editable location */
  function initFindMap() {
    var els = document.querySelectorAll('[data-findmap]');
    if (!els.length) return;
    function loadLeaflet(cb) {
      if (window.L) { cb(); return; }
      var css = document.createElement('link');
      css.rel = 'stylesheet'; css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      css.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY='; css.crossOrigin = '';
      document.head.appendChild(css);
      var js = document.createElement('script');
      js.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      js.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo='; js.crossOrigin = '';
      js.onload = cb; document.head.appendChild(js);
    }
    loadLeaflet(function () {
      els.forEach(function (el) {
        var lat = parseFloat(el.getAttribute('data-lat')), lng = parseFloat(el.getAttribute('data-lng'));
        var zoom = parseInt(el.getAttribute('data-zoom'), 10) || 9;
        if (isNaN(lat) || isNaN(lng)) return;
        var map = L.map(el, { center: [lat, lng], zoom: zoom, minZoom: 5, maxZoom: 12, dragging: false, scrollWheelZoom: false, doubleClickZoom: false, boxZoom: false, keyboard: false, zoomControl: true, attributionControl: true });
        L.tileLayer('https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', { maxZoom: 17, attribution: 'Map data: &copy; OpenStreetMap contributors, SRTM | &copy; OpenTopoMap (CC-BY-SA)' }).addTo(map);
        var loc = L.divIcon({ className: 'findmap__loc', iconSize: [20, 20], iconAnchor: [10, 10] });
        L.marker([lat, lng], { icon: loc, interactive: false, keyboard: false }).addTo(map);
      });
    });
  }

  /* Tabs — panel switching (v10 Tabs) */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-tabs]').forEach(function (tabs) {
      if (tabs.getAttribute('data-ready') === '1') return;
      tabs.setAttribute('data-ready', '1');
      var btns = Array.prototype.slice.call(tabs.querySelectorAll('.tabs__btn'));
      var panels = Array.prototype.slice.call(tabs.querySelectorAll('.tabs__panel'));
      btns.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.setAttribute('aria-selected', 'false'); });
          panels.forEach(function (p) { p.hidden = true; });
          btn.setAttribute('aria-selected', 'true');
          if (panels[i]) panels[i].hidden = false;
        });
      });
    });
  }

  /* Accordion / FAQ — toggle (v10 Accordion) */
  function initAccordion(root) {
    (root || document).querySelectorAll('[data-accordion]').forEach(function (acc) {
      if (acc.getAttribute('data-ready') === '1') return;
      acc.setAttribute('data-ready', '1');
      acc.querySelectorAll('.accordion__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.accordion__item');
          var open = item.getAttribute('data-open') === 'true';
          item.setAttribute('data-open', open ? 'false' : 'true');
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
    });
  }

  /* Countdown — tick from data-deadline (v10 Countdown) */
  function initCountdown(root) {
    (root || document).querySelectorAll('[data-countdown]').forEach(function (cd) {
      if (cd.getAttribute('data-ready') === '1') return;
      cd.setAttribute('data-ready', '1');
      var end = Date.parse((cd.getAttribute('data-deadline') || '').replace(' ', 'T'));
      if (isNaN(end)) return;
      var cells = {
        days: cd.querySelector('[data-cd="days"]'), hrs: cd.querySelector('[data-cd="hrs"]'),
        min: cd.querySelector('[data-cd="min"]'), sec: cd.querySelector('[data-cd="sec"]')
      };
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var s = Math.floor(diff / 1000);
        if (cells.days) cells.days.textContent = pad(Math.floor(s / 86400));
        if (cells.hrs) cells.hrs.textContent = pad(Math.floor((s % 86400) / 3600));
        if (cells.min) cells.min.textContent = pad(Math.floor((s % 3600) / 60));
        if (cells.sec) cells.sec.textContent = pad(s % 60);
        if (diff <= 0 && cd._t) { clearInterval(cd._t); }
      }
      tick();
      cd._t = setInterval(tick, 1000);
    });
  }

  /* Video frame — click poster to embed (v10 VideoFrame) */
  function initVideoFrame(root) {
    (root || document).querySelectorAll('[data-videoframe]').forEach(function (vf) {
      if (vf.getAttribute('data-ready') === '1') return;
      vf.setAttribute('data-ready', '1');
      vf.addEventListener('click', function () {
        var url = vf.getAttribute('data-embed') || '';
        var embed = '';
        var yt = url.match(/(?:youtu\.be\/|v=)([\w-]{11})/);
        var vim = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
        if (yt) embed = 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1';
        else if (vim) embed = 'https://player.vimeo.com/video/' + vim[1] + '?autoplay=1';
        if (!embed) return;
        var f = document.createElement('iframe');
        f.src = embed; f.allow = 'autoplay; fullscreen; picture-in-picture'; f.setAttribute('allowfullscreen', '');
        vf.innerHTML = ''; vf.appendChild(f); vf.style.cursor = 'default';
      });
    });
  }

  /* Auto-fit stat numbers: shrink font-size until the value fits its container */
  function initFit(root) {
    var els = (root || document).querySelectorAll('.stat-fit');
    els.forEach(function (el) {
      var parent = el.parentElement;
      if (!parent) return;
      if (!el.getAttribute('data-fit-base')) {
        el.setAttribute('data-fit-base', parseFloat(getComputedStyle(el).fontSize));
      }
      var base = parseFloat(el.getAttribute('data-fit-base'));
      el.style.fontSize = base + 'px';
      var size = base, guard = 0;
      while (el.scrollWidth > parent.clientWidth && size > 11 && guard < 80) {
        size -= 1; guard += 1; el.style.fontSize = size + 'px';
      }
    });
  }
  var fitPending = false;
  function scheduleFit() { if (fitPending) return; fitPending = true; requestAnimationFrame(function () { fitPending = false; initFit(); }); }
  window.addEventListener('resize', scheduleFit);
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { initFit(); }); }

  function boot() { initDrawer(); initDropdowns(); initReveal(); initQty(); initProductGallery(); initSliders(); initMarquee(); initTimeline(); initFilters(); initFindMap(); initTabs(); initAccordion(); initCountdown(); initVideoFrame(); initFit(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();